module.exports = __webpack_public_path__ + "static/img/grappolo.17760c2.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/visiteinCantina/grappolo.png
// module id = M4Nt
// module chunks = 1